<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #InvitacionQuiniela
    v-layout(align-start justify-start row fill-height)
      v-flex(xs12)
        v-card(style="border-radius:5px;background-color:white;")
          v-card-title(style="padding:8px !important;").justify-center
            img(src='../assets/logo.png' style='height:auto;width:140px;')
        v-card(style="border-radius:5px;background-color:black;")
          v-card-title(style="padding:7px;").justify-center
            span.white--text Invitación Quiniela - Confirmación de Correos

    //- Tarjetas resumen
    v-layout(row wrap style="margin-top:20px;padding:0 16px;" justify-center)
      v-flex(xs12 sm4 md3 style="padding:8px;")
        v-card(style="border-radius:12px;border-left:4px solid #ff6500;")
          v-card-text.text-xs-center
            div(style="font-size:13px;color:#888;margin-bottom:4px;") TOTAL CON CORREO VÁLIDO
            div(style="font-size:36px;font-weight:900;color:#1a1a2e;") {{ resumen.total || 0 }}
      v-flex(xs12 sm4 md3 style="padding:8px;")
        v-card(style="border-radius:12px;border-left:4px solid #27ae60;")
          v-card-text.text-xs-center
            div(style="font-size:13px;color:#888;margin-bottom:4px;") CONFIRMADOS
            div(style="font-size:36px;font-weight:900;color:#27ae60;") {{ resumen.confirmados || 0 }}
      v-flex(xs12 sm4 md3 style="padding:8px;")
        v-card(style="border-radius:12px;border-left:4px solid #e74c3c;")
          v-card-text.text-xs-center
            div(style="font-size:13px;color:#888;margin-bottom:4px;") PENDIENTES
            div(style="font-size:36px;font-weight:900;color:#e74c3c;") {{ resumen.pendientes || 0 }}
      v-flex(xs12 sm4 md3 style="padding:8px;")
        v-card(style="border-radius:12px;border-left:4px solid #8e44ad;")
          v-card-text.text-xs-center
            div(style="font-size:13px;color:#888;margin-bottom:4px;") INVITACIÓN ENVIADA
            div(style="font-size:36px;font-weight:900;color:#8e44ad;") {{ resumen.invitacionEnviada || 0 }}
      v-flex(xs12 sm4 md3 style="padding:8px;")
        v-card(style="border-radius:12px;border-left:4px solid #f39c12;")
          v-card-text.text-xs-center
            div(style="font-size:13px;color:#888;margin-bottom:4px;") SIN INVITACIÓN
            div(style="font-size:36px;font-weight:900;color:#f39c12;") {{ resumen.sinInvitacion || 0 }}

    //- Barra de progreso
    v-layout(row wrap justify-center style="padding:0 24px;margin-top:8px;")
      v-flex(xs12 sm10 md9)
        div(style="font-size:12px;color:#888;margin-bottom:6px;") Porcentaje confirmado: {{ porcentaje }}%
        v-progress-linear(:value="porcentaje" color="#27ae60" height="10" style="border-radius:10px;")

    //- Prueba
    v-layout(row wrap justify-center style="margin-top:24px;padding:0 16px;")
      v-flex(xs12 sm10 md9)
        v-card(style="border-radius:12px;padding:20px;border-left:4px solid #3498db;")
          v-card-title(style="padding-bottom:12px;font-weight:700;") Envío de Prueba
          v-card-text
            v-layout(row wrap align-center)
              v-flex(xs12 sm8)
                v-text-field(
                  v-model="emailPrueba"
                  outline
                  label="Correo para prueba"
                  prepend-inner-icon="email"
                  hide-details
                )
              v-flex(xs12 sm4 style="padding-left:8px;")
                v-btn(
                  style="background:#3498db;border-radius:10px;color:white;margin-top:4px;"
                  @click.native="enviarPrueba"
                  :loading="enviandoPrueba"
                  :disabled="!emailPrueba || enviandoPrueba"
                  block
                ) Enviar prueba

    //- Acciones
    v-layout(row wrap justify-center style="margin-top:24px;padding:0 16px;")
      v-flex(xs12 sm10 md9)
        v-card(style="border-radius:12px;padding:20px;")
          v-card-title(style="padding-bottom:12px;font-weight:700;") Envío de Invitaciones
          v-card-text
            v-checkbox(
              v-model="soloSinPassword"
              label="Enviar solo a clientes sin contraseña asignada"
              color="#ff6500"
              hide-details
              style="margin-bottom:8px;"
            )
            v-checkbox(
              v-model="soloNoEnviados"
              label="Enviar solo a clientes que NO han recibido la invitación aún"
              color="#8e44ad"
              hide-details
              style="margin-bottom:16px;"
            )
            p(style="font-size:13px;color:#666;margin-bottom:20px;")
              | El sistema enviará el email con credenciales + invitación a la Quiniela a todos los clientes con correo registrado.
              | Si tienen RIF, la contraseña será los primeros 6 dígitos numéricos de su RIF.
            v-layout(row wrap)
              v-btn(
                style="background:#ff6500;border-radius:10px;color:white;"
                @click.native="enviar"
                :loading="enviando"
                :disabled="enviando"
              ) Enviar invitaciones
              v-btn(
                style="border-radius:10px;margin-left:8px;"
                @click.native="cargarResumen"
                :loading="cargando"
              ) Actualizar resumen
              v-btn(
                style="background:#8e44ad;color:white;border-radius:10px;margin-left:8px;"
                @click.native="sincronizarMailbaby"
                :loading="sincronizando"
                :disabled="sincronizando"
              ) Sincronizar desde MailBaby
          v-card-text(style="padding-top:0;")
            v-layout(row wrap align-center style="margin-top:8px;")
              v-flex(xs12 sm5 md4)
                v-text-field(
                  v-model="syncFechaInicio"
                  label="Desde fecha (para sincronizar, ej: 2026-06-18)"
                  outline
                  dense
                  hide-details
                  type="date"
                )

    v-layout(v-if="resultadoSync" row wrap justify-center style="margin-top:8px;padding:0 16px;")
      v-flex(xs12 sm10 md9)
        v-alert(type="info" :value="true" style="border-radius:12px;")
          | Sincronización completada: {{ resultadoSync.marcados }} clientes marcados como recibidos, {{ resultadoSync.noEncontrados }} emails no encontrados en BD (de {{ resultadoSync.totalEnMailbaby }} entregados en MailBaby).

    //- Resultado del envío
    v-layout(v-if="resultado" row wrap justify-center style="margin-top:16px;padding:0 16px;")
      v-flex(xs12 sm10 md9)
        v-alert(type="success" :value="true" style="border-radius:12px;")
          | Proceso completado: {{ resultado.enviados }} enviados, {{ resultado.errores }} errores, {{ resultado.omitidos || 0 }} omitidos de {{ resultado.total }} clientes totales.

    //- Log de entregas mailbaby
    v-layout(row wrap justify-center style="margin-top:32px;padding:0 16px 32px;")
      v-flex(xs12 sm12 md11)
        v-card(style="border-radius:12px;")
          v-card-title(style="padding:16px 20px 8px;font-weight:700;font-size:16px;display:flex;align-items:center;gap:12px;flex-wrap:wrap;")
            span 📬 Log de entregas (MailBaby)
            v-spacer
            v-select(
              v-model="logFiltroEntrega"
              :items="[{text:'Todos',value:''},{text:'Entregados ✅',value:'1'},{text:'No entregados ❌',value:'0'}]"
              item-text="text"
              item-value="value"
              label="Estado"
              outline
              dense
              hide-details
              style="max-width:180px;"
            )
            v-text-field(
              v-model="logFiltroEmail"
              label="Buscar email"
              prepend-inner-icon="search"
              outline
              dense
              clearable
              hide-details
              style="max-width:220px;"
              @keyup.enter.native="cargarLog"
            )
            v-btn(style="background:#ff6500;color:white;border-radius:8px;" small :loading="cargandoLog" @click.native="cargarLog") Ver log
          v-card-text(style="padding:0;")
            div(v-if="cargandoLog" style="text-align:center;padding:40px;")
              v-progress-circular(indeterminate color="#ff6500")
            div(v-else-if="logError" style="padding:16px;")
              v-alert(type="error" :value="true") {{ logError }}
            div(v-else-if="logEmails.length === 0 && logCargado" style="text-align:center;padding:32px;color:#888;") No se encontraron registros.
            v-data-table(
              v-else-if="logEmails.length > 0"
              :headers="logHeaders"
              :items="logEmails"
              :rows-per-page-items="[50, 100, 200]"
              :pagination.sync="logPagination"
              style="font-size:13px;"
            )
              template(v-slot:items="props")
                td {{ props.item.recipient || props.item.to }}
                td
                  v-chip(
                    :color="props.item.delivered == 1 ? 'green' : 'red'"
                    text-color="white"
                    small
                  ) {{ props.item.delivered == 1 ? '✅ Entregado' : '❌ Fallido' }}
                td {{ props.item.created }}
                td(style="font-size:11px;max-width:220px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;" :title="props.item.response") {{ props.item.response }}
          v-card-text(v-if="logTotal > 0" style="padding:8px 16px;color:#888;font-size:12px;")
            | Mostrando {{ logEmails.length }} de {{ logTotal }} registros
</template>

<script>
import Api from "@/services/methods";
export default {
  name: "InvitacionQuiniela",
  data: () => ({
    resumen: { total: 0, confirmados: 0, pendientes: 0 },
    soloSinPassword: false,
    soloNoEnviados: true,
    enviando: false,
    sincronizando: false,
    resultadoSync: null,
    syncFechaInicio: new Date().toISOString().slice(0, 10),
    cargando: false,
    resultado: null,
    emailPrueba: '',
    enviandoPrueba: false,
    // log mailbaby
    logEmails: [],
    logTotal: 0,
    logCargado: false,
    cargandoLog: false,
    logError: null,
    logFiltroEntrega: '',
    logFiltroEmail: '',
    logPagination: { rowsPerPage: 50 },
    logHeaders: [
      { text: 'Destinatario', value: 'recipient', sortable: true },
      { text: 'Estado', value: 'delivered', sortable: true },
      { text: 'Fecha', value: 'created', sortable: true },
      { text: 'Respuesta SMTP', value: 'response', sortable: false }
    ]
  }),
  computed: {
    porcentaje() {
      if (!this.resumen.total) return 0
      return Math.round((this.resumen.confirmados / this.resumen.total) * 100)
    }
  },
  created() {
    this.cargarResumen()
  },
  methods: {
    cargarResumen() {
      this.cargando = true
      Api.get("clientesWeb/invitacion/resumen")
        .then(res => { this.resumen = res.data })
        .catch(err => console.error(err))
        .finally(() => { this.cargando = false })
    },
    enviarPrueba() {
      this.enviandoPrueba = true
      Api.post('clientesWeb/invitacion/test', { email: this.emailPrueba })
        .then(() => {
          this.$swal.fire('Enviado', `Email de prueba enviado a ${this.emailPrueba}`, 'success')
        })
        .catch(err => {
          console.error(err)
          this.$swal.fire('Error', 'No se pudo enviar el email de prueba.', 'error')
        })
        .finally(() => { this.enviandoPrueba = false })
    },
    sincronizarMailbaby() {
      this.$swal.fire({
        title: '¿Sincronizar con MailBaby?',
        text: 'Se consultará el historial de MailBaby y se marcarán en la BD los clientes cuya invitación fue entregada.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, sincronizar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#8e44ad'
      }).then(result => {
        if (!result.value) return
        this.sincronizando = true
        this.resultadoSync = null
        Api.post('clientesWeb/mailbaby/sincronizar', { startDate: this.syncFechaInicio || undefined })
          .then(res => {
            this.resultadoSync = res.data
            this.cargarResumen()
            this.$swal.fire('Listo', `${res.data.marcados} clientes marcados como recibidos.`, 'success')
          })
          .catch(err => {
            console.error(err)
            this.$swal.fire('Error', 'No se pudo sincronizar con MailBaby.', 'error')
          })
          .finally(() => { this.sincronizando = false })
      })
    },
    cargarLog() {
      this.cargandoLog = true
      this.logError = null
      const params = { limit: 200 }
      if (this.logFiltroEntrega !== '') params.delivered = this.logFiltroEntrega
      if (this.logFiltroEmail) params.to = this.logFiltroEmail
      Api.get('clientesWeb/mailbaby/log', { params })
        .then(res => {
          this.logEmails = res.data.emails || []
          this.logTotal = res.data.total || 0
          this.logCargado = true
        })
        .catch(err => {
          this.logError = err.response && err.response.data ? JSON.stringify(err.response.data) : 'Error al consultar el log'
        })
        .finally(() => { this.cargandoLog = false })
    },
    enviar() {
      this.$swal.fire({
        title: "¿Confirmar envío?",
        text: `Se enviará el email a ${this.soloSinPassword ? 'clientes sin contraseña' : 'todos los clientes con correo'}. Esto puede tomar varios minutos.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, enviar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#ff6500"
      }).then(result => {
        if (!result.value) return
        this.enviando = true
        this.resultado = null
        Api.post("clientesWeb/invitacion/enviar", { soloSinPassword: this.soloSinPassword, soloNoEnviados: this.soloNoEnviados })
          .then(res => {
            this.resultado = res.data
            this.cargarResumen()
            this.$swal.fire("Listo", `${res.data.enviados} emails enviados correctamente.`, "success")
          })
          .catch(err => {
            console.error(err)
            this.$swal.fire("Error", "Ocurrió un error al enviar. Revisa la consola.", "error")
          })
          .finally(() => { this.enviando = false })
      })
    }
  }
}
</script>
